/* BETWEEN SETS — interactivity */
(function () {
  /* ---- Mobile nav ---- */
  function initNav() {
    var t = document.querySelector('[data-nav-toggle]');
    var n = document.querySelector('[data-nav]');
    if (!t || !n || t.dataset.bound) return;
    t.dataset.bound = '1';
    t.addEventListener('click', function () {
      n.classList.toggle('open');
      t.setAttribute('aria-expanded', n.classList.contains('open') ? 'true' : 'false');
    });
  }

  /* ---- Scroll reveal ----
     Distinct move per section. Replays every time an element enters the
     viewport (resets when it scrolls fully out). Injects its own CSS. */
  var CSS = ''
    + '.rv{transition:opacity .75s cubic-bezier(.22,.61,.36,1),transform .75s cubic-bezier(.22,.61,.36,1),clip-path .85s cubic-bezier(.76,0,.24,1),filter .75s ease;will-change:opacity,transform}'
    + '.rv-up{opacity:0;transform:translateY(38px)}'
    + '.rv-down{opacity:0;transform:translateY(-34px)}'
    + '.rv-left{opacity:0;transform:translateX(-54px)}'
    + '.rv-right{opacity:0;transform:translateX(54px)}'
    + '.rv-scale{opacity:0;transform:scale(.85)}'
    + '.rv-pop{opacity:0;transform:translateY(24px) scale(.94)}'
    + '.rv-clip{opacity:0;clip-path:inset(0 0 100% 0);transform:translateY(14px)}'
    + '.rv-rotate{opacity:0;transform:translateY(34px) rotate(-5deg)}'
    + '.rv-blur{opacity:0;filter:blur(14px);transform:scale(1.04)}'
    + '.rv-zoom{opacity:0;transform:scale(1.14)}'
    + '.rv-fade{opacity:0}'
    + '.rv.is-visible{opacity:1;transform:none;clip-path:inset(0 0 0 0);filter:none}'
    + '.post.rv .post__media img{transform:scale(1.1);transition:transform 1.1s cubic-bezier(.22,.61,.36,1)}'
    + '.post.rv.is-visible .post__media img{transform:scale(1)}';

  function initReveal() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    if (!document.getElementById('bs-reveal-css')) {
      var s = document.createElement('style');
      s.id = 'bs-reveal-css';
      s.textContent = CSS;
      document.head.appendChild(s);
    }

    var scope = document.getElementById('MainContent') || document.body;

    function add(el, cls, delay) {
      if (!el || el.classList.contains('rv')) return;
      el.classList.add('rv', cls);
      if (delay) el.style.transitionDelay = delay.toFixed(2) + 's';
    }
    function group(containerSel, itemSel, cls, step) {
      scope.querySelectorAll(containerSel).forEach(function (c) {
        c.querySelectorAll(itemSel).forEach(function (el, i) { add(el, cls, i * step); });
      });
    }

    /* ---- one signature move per section ---- */
    scope.querySelectorAll('.section-head').forEach(function (head) {
      add(head.querySelector('.label'), 'rv-left', 0);   // label slides in
      add(head.querySelector('h2'), 'rv-clip', 0.08);    // heading wipes up
    });
    group('.tiles', '.tile', 'rv-rotate', 0.09);         // topics: tilt + rise
    group('.steps', '.step', 'rv-left', 0.08);           // approach: slide from left
    group('.posts', '.post', 'rv-clip', 0.08);           // blog: wipe + image zoom
    group('.xform', '.xform__item', 'rv-zoom', 0.10);    // transformations: zoom out
    scope.querySelectorAll('.about__img').forEach(function (e) { add(e, 'rv-left', 0); });   // about: split...
    scope.querySelectorAll('.about__b').forEach(function (e) { add(e, 'rv-right', 0.06); }); // ...text from right
    scope.querySelectorAll('.approach__aside').forEach(function (e) { add(e, 'rv-up', 0); });
    scope.querySelectorAll('.contact').forEach(function (e) { add(e, 'rv-blur', 0); });      // contact: blur in
    scope.querySelectorAll('.marquee').forEach(function (e) { add(e, 'rv-fade', 0); });

    var items = Array.prototype.slice.call(scope.querySelectorAll('.rv'));

    function reveal() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = 0; i < items.length; i++) {
        var r = items[i].getBoundingClientRect();
        var inBand = r.top < vh * 0.86 && r.bottom > vh * 0.10;
        var fullyOut = r.bottom < -40 || r.top > vh + 40;
        if (inBand) items[i].classList.add('is-visible');
        else if (fullyOut) items[i].classList.remove('is-visible'); // reset so it replays next time
      }
    }
    var ticking = false;
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(function () { reveal(); ticking = false; }); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', reveal);
    // paint hidden state one frame, then reveal so the first entrance animates
    requestAnimationFrame(function () { requestAnimationFrame(reveal); });
  }

  function init() { initNav(); initReveal(); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();